import { getObjects, createObject, updateObject, deleteObject, exportObjects, createMessage } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

export const messagesConfig = {
  title: "Messages",
  entityLabel: "Message",

  idField: "id",

  rowActions: [
    { key: "edit", label: "Edit", permission: "edit_messages", onlyIfLessThanFiveMinutes: true, action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_messages", onlyIfLessThanFiveMinutes: true, action: "delete" }
  ],

  actionHandlers: {
    edit: ({ entity, setState, setFormParams }) => {
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },
  },

  services: {
    list: getObjects,
    create: createObject,
    update: updateObject,
    delete: deleteObject,

    services_url_names: {
    list: "get_Messages",
    create: "create_message",
    update: "update_message",
    delete: "delete_message",
    },
  },

  attributes: [
    { label: "user_id__profile_picture", value: "user_id__profile_picture", type: "int", is_default:"true", table_hidden: true },
    { label: "content", value: "content", is_default:"true", table_hidden: true },
  
  ],
  conditions: Conditions,

  formFields: [
    {key: "content", label: "content", type: "textarea", placeholder: "Enter description...", validation: ["required"] },
  ],

   defaultFilters : [
    //{ attribute: "ticket_id", condition: "==", value: "", type: "str" }
   ],

  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "Thread",
      filters: [],   // tabIndex 0
    },
    // Users only has "All"
  ],
};
